import React from 'react'
import { generatePath, useParams } from 'react-router-dom'
import { Button, Modal } from 'antd'
import * as Icons from '@ant-design/icons'
import styled from 'styled-components'

import { useApi } from 'admin/lib/Api'
import {
  FormSectionTitle,
  FormSectionWrapper,
  FormSpace
} from 'admin/lib/Forms'

import * as ADMIN_ROUTES from 'admin/routes'

export function DuplicateRecordControls({
  recordSimilarityDetails,
  recordStatus
}) {
  const { accountId, moduleName, projectId, recordId } = useParams<{
    accountId: string
    projectId: string
    moduleName: string
    recordId: string
  }>()

  const api = useApi()
  const SIMILARITY_THRESHOLD = 1.1 // Effectively Switching This Off

  const handleMarkAsDuplicate = async () => {
    // projectId and moduleName is passed in twice because at the moment
    // we expect the duplicate and the winning record to be in the same Project and Module,
    // however this may change in the future.
    if (api) {
      const [, status, error] = await api.markAsDuplicate(
        accountId ? accountId : '',
        projectId ? projectId : '',
        moduleName ? moduleName : '',
        recordId ? recordId : '',
        recordSimilarityDetails?.projectId,
        moduleName ? moduleName : '',
        recordSimilarityDetails?.recordId,
        'QCR word match'
      )

      if (error) {
        console.error(error)
        return Modal.error({
          title: '"Mark as duplicate" Failed',
          content: String(error),
          centered: true
        })
      } else if ([200, 201].includes(status)) {
        //window.close()
        window.location.reload()
      }
    }
    return
  }

  if (
    recordSimilarityDetails?.similarity < SIMILARITY_THRESHOLD ||
    recordId === recordSimilarityDetails?.recordId
  ) {
    return ''
  }

  return (
    <>
      <FormSectionWrapper>
        <FormSectionTitle level={5}>Duplicate Record</FormSectionTitle>
      </FormSectionWrapper>
      <ButtonContainer>
        <Button
          type="primary"
          danger
          icon={<Icons.FlagOutlined />}
          onClick={handleMarkAsDuplicate}
          disabled={recordStatus === 'Void'}
        >
          Mark as duplicate
        </Button>
        <Button
          disabled={!recordSimilarityDetails?.recordId}
          icon={<Icons.EyeOutlined />}
          href={
            recordSimilarityDetails?.recordId
              ? generatePath(ADMIN_ROUTES.RECORD.EDIT, {
                  accountId: accountId,
                  projectId: recordSimilarityDetails.projectId,
                  moduleName: moduleName,
                  recordId: recordSimilarityDetails.recordId
                })
              : '#'
          }
          target="_blank"
        >
          View duplicate
        </Button>
      </ButtonContainer>
      <FormSpace>&nbsp;</FormSpace>
    </>
  )
}

const ButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;

  & .ant-btn > .anticon + span,
  .ant-btn > span + .anticon {
    margin-left: 0;
  }
`
